import { SelectClasses, getSelectUtilityClasses, selectClasses as muiSelectClasses } from '@mui/material';

declare module '@mui/material/Select' {
  interface SelectClasses {
    placeholder: string;
    label: string;
  }
}

export const selectClasses: SelectClasses = {
  ...muiSelectClasses,
  placeholder: getSelectUtilityClasses('placeholder'),
  label: getSelectUtilityClasses('label'),
};
